// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.scrollpanel-structure .p-scrollpanel p {
  padding: 0rem;
  line-height: 1.5;
  margin: 0;
}



.scrollpanel-structure .p-scrollpanel.custombar1 .p-scrollpanel-bar {
  background-color: #28477f;
  opacity: 1;
  transition: background-color .2s;
}

.scrollpanel-structure .p-scrollpanel.custombar1 .p-scrollpanel-bar:hover {
  background-color: #28477f;
}


.scrollpanel-structure .p-col-12 {
  padding: 0rem;
}

.custom-scrolltop {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 4px;
  background-color: #28477f !important;
}
.custom-scrolltop:hover {
  background-color: #28477f !important;
}

.custom-scrolltop .p-scrolltop-icon {
  font-size: 1rem;
  color: var(--primary-color-text);
}`, "",{"version":3,"sources":["webpack://./src/scene-d/HA/HAView/HAViewInformation/ScrollPanel.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;AACX;;;;AAIA;EACE,yBAAyB;EACzB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC","sourcesContent":["\n.scrollpanel-structure .p-scrollpanel p {\n  padding: 0rem;\n  line-height: 1.5;\n  margin: 0;\n}\n\n\n\n.scrollpanel-structure .p-scrollpanel.custombar1 .p-scrollpanel-bar {\n  background-color: #28477f;\n  opacity: 1;\n  transition: background-color .2s;\n}\n\n.scrollpanel-structure .p-scrollpanel.custombar1 .p-scrollpanel-bar:hover {\n  background-color: #28477f;\n}\n\n\n.scrollpanel-structure .p-col-12 {\n  padding: 0rem;\n}\n\n.custom-scrolltop {\n  width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 4px;\n  background-color: #28477f !important;\n}\n.custom-scrolltop:hover {\n  background-color: #28477f !important;\n}\n\n.custom-scrolltop .p-scrolltop-icon {\n  font-size: 1rem;\n  color: var(--primary-color-text);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
